import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";
import {ViewType} from "../../../../gd/const/views/view-type";

export const MY_WORK_WORKLOAD_CONFIG : ViewPersonalConfig = {
    type            : ViewType.MY_WORK_WORKLOAD,
    name            : 'My Workload',
    icon            : 'i5-timeline',
    iconSvg         : 'isvg-view-workload',
    url             : 'my-workload',
    description     : 'All your tasks in the timeline view',
    defaultLocation : PersonalViewLocation.HOME_MORE
}
